import { CompositeDecorator } from "draft-js";

import linkDecorator from "./linkDecorator";
import linkifyDecorator from "./linkifyDecorator";
import mentionDecorator from "./mentionDecorator";
import makeSuggestionsDecorator from "./makeSuggestionsDecorator";

const getDecorator = props => new CompositeDecorator([
  linkDecorator,
  linkifyDecorator,
  mentionDecorator(props),
  makeSuggestionsDecorator(props)
]);

export default getDecorator;
